import { useState, useRef } from 'react';
import { original, rose, vaporwave, matrix } from 'react95/dist/themes';
import { BrowserRouter, Router, Routes, Route, Link, useNavigate} from "react-router-dom";
import { createGlobalStyle, ThemeProvider, createTheme} from 'styled-components';
import {
    AppBar,
  Button,
  MenuList,
  MenuListItem,
  ScrollView,
  Separator,
  Toolbar,
    Frame,
  Window,
    Handle,
    
  WindowContent,
  WindowHeader,
    TextInput,
    styleReset
} from 'react95';

const AboutPage = () => {
    const imgBox = useRef(null);
    const descBox = useRef(null);
    
    
    const Entries = [
        {
            name: "Jeans",
            description: "Blah blah blah, test",
            photos: [
                "/images/works/comics/Jeans.png"
            ]
        },
        {
            name: "It's not that Deep",
            description: "Blah blah blah, test",
            photos: [
                "/images/works/comics/ItsnotthatdeepFinal.png"
            ]
        },
        {
            name: "All in My Front Yard",
            description: "Blah blah blah, test",
            photos: [
                "/images/works/comics/AllInMyFrontYard.jpg",
                "/images/works/comics/CanYuo.jpg",
                "/images/works/comics/FallingDown.jpg",
                "/images/works/comics/garage.jpg",
                "/images/works/comics/Hatemonger.jpg",
                "/images/works/comics/ThePopOut.jpg",
            ]
        },
        {
            name: "Mouse Date at the Grand Park",
            description: "Mouse date at the Grand Park is the first artwork I drew as a discoved that I may possibly be a furry. It was made for a girl I used to go out with back in the Summer of '25 a relationship that didn't really work out for a lot of reasons I'll probably write about some day but for now I'll leave vague. Really early in... whatever you would call us, on we wanted to go on a little picnic date over in Grand Park with a cheese plate, crackers, and wine. We called this hypothetical date, the mouse date. This date never materialized because she lived out in Ventura and didn't have a car so our only dates were me driving an hour through Ventura County (AKA the middle of nowhere) to go to the beach with her (which was still pretty fun it it's own right). Also I was 18 and herself 20 so we're both under the legal American drinking age and couldn't buy wine. Also Los Angeles open container laws wouldn't permit us drinking it out in public if we wanted to. Alas, the concept of a so called mouse date was left only to be rendered onto a digital canvas by myself. \n\n This is clearly a pretty early work of mine, I always like rough linework but even for me it's a little sloppy. The colors and shading are a little too high contrast for my taste now and certain details of my style like mouse skin color, whether they'd be sized like regular mice or humans or whether they wear clothes are all questions still kinda left open here. \n\n however despite it's clear novice nature I think the use of colors to create the hazy sunset vibe of LA paired with the detail and emotion on both of their faces portray the deep calm and serenity that picnic dates in the park can bring.\n\n I highlight this work because it marks a seminole moment in finding my stylistic voice as an artist.",
            photos: [
                "/images/works/comics/Mouse Date at the Grand Park.png"
            ]
        },
        {
            name: "Metro Headcannons",
            description: "Blah blah blah, test",
            photos: [
                "/images/works/comics/A_Line.png",
                "/images/works/comics/B_Line.png",
                "/images/works/comics/C_Line.png",
                "/images/works/comics/D_Line.png",
                "/images/works/comics/E_Line.png",
                     
            ]
        }
        
    ]
    
    const [selectedEntry, setSelectedEntry] = useState(Entries[0]);
    const [photoIndex, setPhotoIndex] = useState(0);
    
    const loadContent = (desc) => {
        descBox.current.innerHtml = desc;
    }
    
    
    const navigate = useNavigate();
    
    const handleRedirect = (dir) => {
        navigate(dir);
    };
    
    const handleEntryClick = (entry) => {
      setSelectedEntry(entry);
      setPhotoIndex(0);
    };
    
    const listItems = Entries.map((Entry, index) =>
                                  <div key={index}>
                                  <MenuListItem style={{ whiteSpace: 'normal', height: 'auto' }} onClick={() => {setSelectedEntry(Entry); setPhotoIndex(0)}}>{Entry.name}</MenuListItem>
                                  <Separator />
                                  </div>
                                  );
    
    return (
            <ThemeProvider theme={rose}>
            <Window resizable className='window' style={{ display: 'block', height: '80vh', width: 'calc(90vh * (3/2))', maxWidth: "800px"}}>
            <WindowHeader className='window-title' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Comics & 2D Art</span>
            <Button style={{ marginRight: '2px', width: '20px', height: '20px', padding: 0 }} onClick={() => handleRedirect('/Backpage')}>
            <span style={{ fontWeight: 'bold', fontSize: '12px' }}>✕</span>
            </Button>
            </WindowHeader>
            
            <WindowContent style={{ height: 'calc(100% - 33px)', padding: 0 }}>
            <Frame variant='well' className='footer' style={{ height: '100%', margin: 0, display: 'flex', flexDirection: "column" }}>
                <div style={{ 
                    width: '100%', 
                    flex: 5,
                    background: 'black', 
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden'
                    }}>
                <img
                    src={selectedEntry.photos[photoIndex]}
                    alt={selectedEntry.name}
                    style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain'
                    }}
                />
                </div>
            
              
              <div style={{ display: 'flex', flexDirection: 'row', flex: 3, overflow: 'hidden' }}>
                <ScrollView style={{ height: '100%', flex: 1 }}>
                  <MenuList style={{ display: 'flex', flexDirection: 'column' }}>
                    {listItems}
                  </MenuList>
                </ScrollView>
                <ScrollView style={{ height: '100%', flex: 1 }}>
                  <div style={{ padding: '1rem' }}>
                  {selectedEntry.description.split('\n\n').map((para, i) => (
                    <p key={i}>{para}</p>
                    ))}
                  </div>
                </ScrollView>
              </div>
                
              <div style={{ width: '100%', flex: 1, display: 'flex', flexDirection: 'column' }}>
              {selectedEntry.photos.length > 1 ?
                    <MenuList inline>
                        
                    <MenuListItem onClick={() => setPhotoIndex(i => Math.max(i - 1, 0))}>Previous</MenuListItem>
                    <MenuListItem onClick={() => setPhotoIndex(i => Math.min(i + 1, selectedEntry.photos.length - 1))}>Next</MenuListItem>
                      </MenuList> : <div></div>
                }
                <Button 
                  className='big-button'
                  style={{ width: '100%', height: '100%', flex: 1, display: "none"}} 
                  fstyle={{ height: '100%', width: '100%', fontSize: '2rem !important' }} 
                  onClick={() => linkOut(selectedEntry.link)}
                >
                  Check this out on Roblox
                </Button>
              </div>
              </Frame>

            
            
            
            </WindowContent>
            
          </Window>
          
          
    </ThemeProvider>
  );
}

export default AboutPage;
